import { Set } from 'immutable'
import { createSelector } from 'reselect'
import { activeConversation } from 'app/modules/conversation/selectors'
import { BareUser } from 'app/modules/user/models'
import { currentUser } from 'app/modules/user/selectors'
import { UserTypes } from 'utils/UserTypes'

export const getParticipants = createSelector(
  activeConversation,
  (conversation) => {
    if (conversation) {
      return [{ id: conversation.endUserId, type: conversation.endUserType }]
    }
    return []
  }
)

const root = (state) => state.get('typing')

const typingUserIds = (state, conversationId) => {
  return root(state).typingUsersByConversationId.get(conversationId, Set())
}

export const typingUsers = createSelector(
  typingUserIds,
  currentUser,
  (typingUsersIds, currentUser) => {
    return typingUsersIds
      .map((userTypeAndId) => BareUser({ type: userTypeAndId.first(), id: userTypeAndId.last() }))
      .filter((user) => !(user.id === currentUser.id && user.type === currentUser.type))
      .toList()
  })

export const typingEndUsers = createSelector(
  typingUserIds,
  currentUser,
  (typingUsersIds, currentUser) => {
    return typingUsersIds
      .map((userTypeAndId) => BareUser({ type: userTypeAndId.first(), id: userTypeAndId.last() }))
      .filter((user) => user.type === UserTypes.END_USER || user.type === UserTypes.LEAD)
      .map((user) => user.id)
      .toList()
  })

export const typingAgents = createSelector(
  typingUserIds,
  currentUser,
  (typingUsersIds, currentUser) => {
    return typingUsersIds
      .map((userTypeAndId) => BareUser({ type: userTypeAndId.first(), id: userTypeAndId.last() }))
      .filter((user) => user.type === currentUser.type && user.id !== currentUser.id) // excludes current user
      .map((user) => user.id)
      .toList()
  })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/typing/selectors.js